import axios from 'axios';
import http from 'http';
import https from 'https';

let axiosInstance = null;
const httpAgent = new http.Agent({
  family: 4,
});
const httpsAgent = new https.Agent({
  family: 4,
});
axios.defaults.httpAgent = httpAgent;
axios.defaults.httpsAgent = httpsAgent;

export const getAxiosInstance = () => {
  if (!axiosInstance) {
    axiosInstance = axios.create({
      httpAgent,
      httpsAgent,
    });
  }
  return axiosInstance;
};
